import { Fragment } from 'react';
import PropTypes from 'prop-types';

// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getPlainText, getRichText
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { isLiveChatPlainText, isEmailCMF
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/cmfComparators';
// @ts-expect-error module not typed
import ContentText from '../primary-message/ContentText';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageContent = ({
  message,
  plainTextMode,
  showTruncatedMessageContent
}) => {
  const messageBodyRichText = getRichText(message);
  const isPlainText = plainTextMode || isLiveChatPlainText(message) || !messageBodyRichText;
  const contentText = isPlainText ? getPlainText(message) : messageBodyRichText;
  const hasEmailMetadata = isEmailCMF(message);
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(ContentText, {
      contentText: contentText,
      isPlainText: isPlainText,
      isShowingMessageReplies: showTruncatedMessageContent,
      dataTestId: hasEmailMetadata ? 'email-message-content' : 'primary-message-content'
    })
  });
};
MessageContent.displayName = 'MessageContent';
MessageContent.propTypes = {
  message: PropTypes.oneOfType([RecordPropType('CommonMessage'), RecordPropType('WorkflowGeneratedUserMessage')]).isRequired,
  plainTextMode: PropTypes.bool.isRequired,
  showTruncatedMessageContent: PropTypes.bool.isRequired
};
export default MessageContent;